import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'nonDeleteDirtyStatus' })
export class DeleteDirtyStatusPipe implements PipeTransform {
  transform(potentialDirtyElements: any[]): any {
    return potentialDirtyElements.filter((element) => element.dirtyStatus !== cad.DirtyStatus.DELETE ? true : false);
  }
}
